import React from 'react';
import Card from './card.jsx';
import CardLink from './card_link.jsx';

const Subsection = (props) => {
  let cardWidth = 0;
  if (props.cards[0]) {
    cardWidth = props.cards[0].cardWidth;
  }
  return (
    <>
      <div>
        <h1 className='marketplace-section-title'>{props.title}</h1>
        <div className='marketplace-section'>
          { props.cards.map((card) => <Card key={card.key} {...card}/>) }
          <CardLink path={props.path} cardWidth={cardWidth}/>
        </div>
      </div>
    </>
  );
};

export default Subsection;
